export default __webpack_public_path__ + "static/media/orange_small.3013045b.png";